// Accordion tabs
window.addEventListener("load", function () {
    let myTabs = document.querySelectorAll("ul.nav-tabs > li");
    myTabs.forEach((item) => {
        if (!item.classList.contains('static')) {
            item.addEventListener("click", (e) => {
                const tabsID = `#${item.parentElement.parentElement.id}`;

                const myUniqueTabs = document.querySelectorAll(`${tabsID} ul.nav-tabs > li`);
                for (let i = 0; i < myUniqueTabs.length; i++) {
                    myUniqueTabs[i].classList.remove("active");
                }
                item.classList.add("active");

                let myUniqueContentPanes = document.querySelectorAll(`${tabsID} .tab-pane`);
                for (let i = 0; i < myUniqueContentPanes.length; i++) {
                    myUniqueContentPanes[i].classList.remove("active");
                }

                let anchorReference = item.querySelector('div');
                let activePaneId = anchorReference.getAttribute("data-href");
                let activePane = document.querySelector(`${tabsID} ${activePaneId}`);
                activePane.classList.add("active");
            })
        }
    })
});